export enum TaskDetailsTab {
  Description = 0,
  Files = 1,
  TimeReports = 2,
  PrivateNotes = 3
}

export interface TaskDetailsTabConfig {
  index: TaskDetailsTab;
  icon: string;
  labelKey: string;
}

export const TASK_DETAILS_TABS: readonly TaskDetailsTabConfig[] = [
  { index: TaskDetailsTab.Description, icon: 'notes', labelKey: 'task-details-desc-section-title' },
  { index: TaskDetailsTab.Files, icon: 'folder', labelKey: 'task-details-desc-section-files' },
  { index: TaskDetailsTab.TimeReports, icon: 'hourglass', labelKey: 'task-details-desc-section-time-reports' },
  { index: TaskDetailsTab.PrivateNotes, icon: 'add_notes', labelKey: 'task-details-desc-section-private-notes' }
];
